import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import LanguageSelector from "./LanguageSwitcher";
import { Footer } from "flowbite-react";
import { translate } from "../i18n/translate";
import { LocalizedLink } from "gatsby-plugin-i18n-l10n";

const FooterComponent = () => {
  return (
    <Footer className="bg-gray-50 dark:bg-gray-800">
      <div className="p-4 py-6 mx-auto max-w-screen-xl md:p-8 lg:-10">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-6">
          <div className="col-span-2">
            <p className="flex my-0 font-light text-gray-500 dark:text-gray-400">
              <svg
                className="mr-2 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              office@noracares.at
            </p>
            <p className="flex my-0 font-light text-gray-500 dark:text-gray-400">
              <svg
                className="mr-2 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
                />
              </svg>{" "}
              +43 (0) 660 / 9155 151{" "}
            </p>
            <p className="flex my-0 font-light text-gray-500 dark:text-gray-400">
              <svg
                className="mr-2 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                />
              </svg>{" "}
              Landstraße 27, 4020 Linz, AT
            </p>
            <ul className="flex mt-5 space-x-6 list-none [&>li]:ml-0">
              <li>
                <a
                  href="https://www.facebook.com/noracares.at"
                  aria-label="Visit Nora Cares Facebook page"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/noracares/"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                  aria-label="Visit Nora Cares LinkedIn page"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.51 8.796v1.697a3.738 3.738 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483 1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.601 1.601 0 0 1 1.6 1.606Z"
                      clip-rule="evenodd"
                    />{" "}
                    <path d="M7.2 8.809H4V19.5h3.2V8.809Z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/noracares/"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                  aria-label="Visit Nora Cares Instagram page"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://open.spotify.com/user/31oowkph4eaks3et4gkh7rbqndwe?si=622ec1a520d54f5c"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                  aria-label="Visit Nora Cares Spotify page"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="-2 4 24 24"
                    aria-hidden="true"
                  >
                    <path d="M13.2 20.84c-0.2 0-0.4-0.08-0.56-0.2-1.84-1.6-5.8-1.12-7.2-0.84-0.44 0.12-0.92-0.2-1-0.64-0.12-0.44 0.2-0.88 0.64-1 0.24-0.04 5.8-1.24 8.64 1.2 0.36 0.32 0.4 0.84 0.08 1.2-0.12 0.16-0.36 0.28-0.6 0.28zM14.2 18.44c-0.16 0-0.32-0.04-0.48-0.16-3.36-2.4-8.48-1.08-8.52-1.08-0.44 0.12-0.92-0.16-1.04-0.6s0.16-0.92 0.6-1.04c0.24-0.08 5.92-1.56 9.96 1.32 0.36 0.28 0.48 0.8 0.2 1.16-0.2 0.28-0.44 0.4-0.72 0.4zM15.24 15.72c-0.16 0-0.32-0.04-0.48-0.16-4.44-2.96-10.04-1.04-10.12-1.04-0.44 0.16-0.88-0.08-1.04-0.52s0.08-0.92 0.52-1.08c0.28-0.08 6.48-2.2 11.6 1.24 0.4 0.24 0.48 0.76 0.24 1.16-0.2 0.24-0.48 0.4-0.72 0.4zM9.6 25.6c-5.28 0-9.6-4.32-9.6-9.6s4.32-9.6 9.6-9.6 9.6 4.32 9.6 9.6-4.32 9.6-9.6 9.6zM9.6 8.08c-4.36 0-7.92 3.56-7.92 7.92s3.56 7.92 7.92 7.92 7.92-3.56 7.92-7.92-3.56-7.92-7.92-7.92z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://pin.it/8vJACbNqO"
                  className="text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                >
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 192 192"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="12"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M62 170 90 62"></path>
                    <path d="M49.235 103a54 54 0 1 1 24.801 22.331"></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
          <div className="lg:mx-auto">
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
              {translate("company")}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 list-none [&>li]:ml-0">
              <li className="mb-4">
                <LocalizedLink to="/about-us/" className=" hover:underline">
                  {translate("aboutUs.meta.title")}
                </LocalizedLink>
              </li>
              <li className="mb-4">
                <LocalizedLink to="/career" className="hover:underline">
                  {translate("career")}
                </LocalizedLink>
              </li>
              <li className="mb-4">
                <LocalizedLink to="/blog" className="hover:underline">
                  {translate("blog")}
                </LocalizedLink>
              </li>
            </ul>
          </div>

          <div className="lg:mx-auto">
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
              {translate("help_center")}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 list-none [&>li]:ml-0">
              <li className="mb-4">
                <LocalizedLink to="/help-center/" className="hover:underline">
                  {translate("help")}
                </LocalizedLink>
              </li>
              <li className="mb-4">
                <a
                  href="mailto:office@noracares.at"
                  className="hover:underline"
                >
                  {translate("contact_us")}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:mx-auto">
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
              {translate("navigation_links")}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 list-none [&>li]:ml-0">
              <li className="mb-4">
                <LocalizedLink to="/caregiver-1/" className="hover:underline">
                  {translate("caregivers")}
                </LocalizedLink>
              </li>
              <li className="mb-4">
                <LocalizedLink
                  to="/careseeker-services/"
                  className="hover:underline"
                >
                  {translate("care_seekers")}
                </LocalizedLink>
              </li>
              <li className="mb-4">
                <LocalizedLink
                  to="/company-services/"
                  className="hover:underline"
                >
                  {translate("business")}
                </LocalizedLink>
              </li>
            </ul>
          </div>
          <div className="lg:mx-auto">
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
              {translate("legal")}
            </h2>
            <ul className="text-gray-500 dark:text-gray-400 list-none [&>li]:ml-0">
              <li className="mb-4">
                <a
                  href={`${process.env.GATSBY_DASHBOARD_URL}/footer/privacy`}
                  className="hover:underline"
                >
                  {translate("privacy_policy")}
                </a>
              </li>
              <li className="mb-4">
                <a
                  href={`${process.env.GATSBY_DASHBOARD_URL}/footer/agb`}
                  className="hover:underline"
                >
                  {translate("terms_of_service")}
                </a>
              </li>
              <li className="mb-4">
                <a
                  href={`${process.env.GATSBY_DASHBOARD_URL}/footer/imprint`}
                  className="hover:underline"
                >
                  {translate("imprint")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

        <div className="flex flex-col justify-between items-center lg:flex-row">
          <a
            href="/"
            className="flex items-center mb-6 text-2xl font-semibold text-gray-900 lg:mb-0 dark:text-white w-[10vw] h-auto"
          >
            <StaticImage
              src="../images/noracares_german.svg"
              alt="noracares Logo"
            />
          </a>
          <span className="block mb-4 text-sm text-gray-500 dark:text-gray-400 lg:mb-0">
            © 2024{" "}
            <a
              target={"_blank"}
              href={`${process.env.GATSBY_DASHBOARD_URL}/authorizationLanding`}
              className="hover:underline"
            >
              noracares
            </a>
            . {translate("all_rights_reserved")}
          </span>

          <LanguageSelector position="top" />
        </div>
      </div>
    </Footer>
  );
};

export default FooterComponent;
